const AssignUnit = {

    // TABS
    "owner": "Owner",
    "tenant": "Tenant",

    // FIELDS
    "zone": "Zone",
    "level": "Level",
    "premise": "Premise",
    "unit": "Unit",
    "user": "User",
    "start_date": "Start Date",
    "documents": "Documents",
    "doc_name": "Document Name",
    "file": "File",
    "terms": "Terms & Conditions",
    "occupancy_status": "Occupancy Status",
    "property_type": "Property Type",
    "charges_paid_by": "Charges Paid By",
    "active_assignments": "Assigned Persons",
    "household": "Household",
    "no_active_assignments": "No active assignments found",

    // PAGE HEADER
    "assign_unit": "Assign Unit",

    // TOAST
    "success_add": "Unit Assigned Successfully",
    "success_update_owner": "Owner Details Updated Successfully",
    "success_update_tenant": "Tenant Details Updated Successfully",

    // ERROR
    "error_zone": "Select Zone",
    "error_level": "Select Level",
    "error_premise": "Select Premise",
    "error_unit": "Select Unit",
    "error_user": "Select User",
    "error_start_date": "Select Start Date",
    "error_doc_name": "Enter Document Name",
    "error_file": "Select File",
    "error_occupancy_status": "Select Occupancy Status",
    "error_property_type": "Select Property Type",
    "error_occupied": "This unit is already occupied and cannot be assigned to a tenant.",
    "warn_select_premise": "Please select a premise first",

}

export default AssignUnit;